import './index.css';
import { useLink } from 'react-router-stack';
import { AllContestListHeader, ContestShare } from '../../component';
import { FlatListWrapper, HeaderWithTimer, RouteWrapper } from '../../../component';
import FlatList from 'flatlist-react';
import ContestCardMWeb from '../../component/contest_card/index_mWeb';
import ContestSortingHeaderMWeb from '../../component/contest_sorting_header/index_mWeb';
import ContestFilterMWeb from '../../component/contest_filter/index_mWeb';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';
import { useSelector } from 'react-redux';
const AllContestListMWeb = ({
  allContestList,
  onUpdateChallenge,
  defaultSort,
  onPressFilter,
  contestCategory,
  totalChallenges,
  onPressCard,
  onPressShare,
  matchStatus,
  gameState,
  totalTeamsCount,
  matchItem,
  matchDelayed,
  gameType,
  onApplyFilter,
  onClearFilter,
  contestFilterVisible,
  onPressFilterDismiss,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss
}: any) => {
  const navigate = useLink();
  const { teamName = '' } = useSelector((state: any) => state.user);
  const renderItem = (item: any) => (
    <ContestCardMWeb
      key={item._id}
      contest={item}
      onPressCard={() => onPressCard(item)}
      onPressShare={() => onPressShare()}
      matchStatus={matchStatus}
      gameState={gameState}
      totalTeamsCount={totalTeamsCount}
      matchItem={matchItem}
      matchDelayed={matchDelayed}
      screenName={'ALL_CONTEST'}
      gameType={gameType}
    />
  );

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onCalledDeadline = () => {
    navigate.push('/', { replace: true });
  };
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          isCreateTeam={false}
          teamName={teamName}
        />

        <ContestSortingHeaderMWeb
          challenges={allContestList}
          onUpdateChallenge={onUpdateChallenge}
          defaultSort={defaultSort}
          onPressFilter={onPressFilter}
          isAllContestList={true}
        />
        <AllContestListHeader contestCategory={contestCategory} totalChallenges={totalChallenges} />
        <FlatListWrapper style={{ paddingBottom: '200px' }}>
          <FlatList list={allContestList} renderItem={renderItem} renderOnScroll />
        </FlatListWrapper>
        <ContestFilterMWeb
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          visible={contestFilterVisible}
          onPressDismiss={onPressFilterDismiss}
        />
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default AllContestListMWeb;
